import React from "react";
import { useContext, useCallback, useEffect, useRef, useState } from "react";
import _ from "lodash";
import { Flex } from "reflexbox";
import styled, { useTheme } from "styled-components";
import { color } from "styled-system";
import { Body } from "../UI/Text";
import Card from "../UI/Card";
import AlertContext from "../../context/alert/AlertContext";

const AlertContainer = styled(Flex)`
  z-index: 10000000;
  flex-direction: column;
  position: fixed;
  right: 1rem;
  top: 1rem;
  gap: 1rem;
  pointer-events: none;
  ${color};
`;

const AlertCard = styled(Card)`
  position: relative;
  align-items: flex-start;
  opacity: 0;
  width: 33vw;
  @keyframes slide-in {
    0% {
      opacity: 1;
      right: -36vw;
      height: 100%;
    }
    5% {
      right: 0;
    }
    95% {
      right: 0;
    }
    99% {
      opacity: 1;
      height: 100%;
    }
    100% {
      height: 0px;
      right: -36vw;
      opacity: 0;
    }
  }

  animation-name: slide-in;
  animation-duration: 6s;
`;

const Alerts = () => {
  const theme = useTheme();
  const { alerts = [], setAlerts } = useContext(AlertContext);

  const alertRef = useRef();
  const [shouldRemove, setShouldRemove] = useState("");

  const removeAlert = useCallback(
    (alertId) => {
      if (alerts?.length > 0) {
        console.log(alertRef.current);
        if (alertRef.current?.children?.length > 0) {
          const a = [...alerts];
          _.remove(a, (a) => a.id === alertId);

          setAlerts(a);
          setShouldRemove("");
          return _.remove(
            alertRef.current.children,
            (child) => child.id === alertId
          );
        }
      }
    },
    [alerts, setAlerts]
  );

  useEffect(() => {
    if (!!shouldRemove) {
      removeAlert(shouldRemove);
    }
  }, [removeAlert, shouldRemove]);

  return (
    <AlertContainer ref={alertRef}>
      {alerts.map((alert) => (
        <AlertCard key={alert.id} backgroundColor={theme[alert.alertColor]}>
          <Body color="white">{alert?.alertText || ""}</Body>
          <div style={{ display: "none" }}>
            {setTimeout(() => {
              setShouldRemove(alert.id);
            }, 7000)}
          </div>
        </AlertCard>
      ))}
    </AlertContainer>
  );
};

export default Alerts;
